export type CollectionStatus =
  | 'Unknown'
  | 'New'
  | 'Syncing'
  | 'Paused'
  | 'Initializing'
  | 'Processing'
  | 'Processed';

export interface Collection {
  id: string;
  projectId: string;
  name: string;
  description?: string;
  status: CollectionStatus | null;
  custodian: { id: string; projectId: string; name: string };
  numQueued: number;
  numProcessed: number;
  bytesProcessed: number;
  originalSource?: { type?: string; bytes?: number; files?: number };
  processingSource?: { type?: string; bytes: number; files: number };
  processingOutput?: { type?: string; bytes: number; files: number };
  processingStart?: number;
  processingEnd?: number;
  createdAt?: number;
  job?: { percentageComplete: number };
}

export interface Custodian {
  id: string;
  name: string;
  projectId: string;
}

export enum PIIDetectionMode {
  Standard = 'gate',
  Enhanced = 'gliner',
}

export interface CreateCollectionBody {
  projectId: string;
  custodian: string;
  name: string;
  description: string;
  ritm: string;
  evidence: string;
  release: string;
  extractFromContainers: boolean;
  extractAttachmentAndEmbeddedDocumentsFromEmails: boolean;
  extractImagesFromEmails: boolean;
  extractDocumentsFromFiles: boolean;
  extractImagesFromFiles: boolean;
  imagePresentationsWithNotes: boolean;
  cancelTranscription: boolean;
  cancelExtractEntities: boolean;
  cancelPdf: boolean;
  cancelOcr: boolean;
  piiDetectionMode: PIIDetectionMode;
}
